import { Size } from '@lumapps/lumx/react';

export * from '@lumapps/lumx/core/utils/classNames';

/**
 * Returns the classname associated to the given size. For example, for Size.xs it returns
 * lumx-size-xs
 * @param size - Size
 * @returns string
 */
export const sizing = (size: Size) => `lumx-size-${size}`;

/**
 * Returns the classname in order to set the "required" style on a label / string.
 * @returns string
 */
export const required = () => 'required';

/**
 * Returns the classname in order to add a separator to an element
 * @returns string
 */
export const separator = () => 'lumx-separator';
